module.exports = __webpack_public_path__ + "static/media/reparaciones.b19f4677.png";